import { Country } from '@scatterlab/zeta-service/apis/types';

const LOCALE_BY_COUNTRY = {
  [Country.Korea]: 'ko',
  [Country.Japan]: 'ja',
} as const;

const getLocaleFromCountry = (country: string) =>
  LOCALE_BY_COUNTRY[country as Country] ?? 'ko';

export default getLocaleFromCountry;
